'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Map = require('./Map');

var _Map2 = _interopRequireDefault(_Map);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Area = require('./components/Area');

var _Area2 = _interopRequireDefault(_Area);

var _Search = require('./components/Search');

var _Search2 = _interopRequireDefault(_Search);

var _Clear = require('./components/Clear');

var _Clear2 = _interopRequireDefault(_Clear);

var _Action = require('./components/Action');

var _Action2 = _interopRequireDefault(_Action);

var _colors = require('../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Colors
// Helpers


var wrapper = _react2.default.createElement('div', {
  style: {
    width: '100%',
    height: '100%',
    position: 'relative'
  }
});

var pause = function pause(time) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, time);
  });
};

var MapZones = function (_Component) {
  _inherits(MapZones, _Component);

  function MapZones() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MapZones);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapZones.__proto__ || Object.getPrototypeOf(MapZones)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rawZones: [],
      zones: [],
      hover: null,
      search: ''
    }, _this.init = function () {
      var zones = [].concat(_toConsumableArray(_this.props.zones.features)).map(function (zone) {
        return [].concat(_toConsumableArray(zone.geometry.coordinates)).map(function (coordinates, index) {
          var path = _this.getCoords(coordinates);

          return {
            id: zone.id,
            key: '' + zone.id + index,
            name: zone.properties.name,
            path: path
          };
        });
      }).flat();

      _this.setState({
        zones: zones,
        rawZones: zones
      });
    }, _this.getCoords = function (coordinates) {
      return coordinates.map(function (coords) {
        return coords.length === 2 ? [{
          lat: coords[1],
          lng: coords[0]
        }] : _this.getCoords(coords);
      }).flat();
    }, _this.styling = function (zone) {
      var _this$props = _this.props,
          selected = _this$props.selected,
          readOnly = _this$props.readOnly;
      var hover = _this.state.hover;
      var defaultStyles = {
        strokeColor: _colors.red,
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: _colors.red
      };
      var isSelected = [].concat(_toConsumableArray(selected)).find(function (sz) {
        return sz === zone.id;
      });
      var isHovered = !readOnly && !!hover && hover.id === zone.id;
      if (isSelected) return isHovered ? _extends({}, defaultStyles, {
        fillOpacity: 0.8
      }) : _extends({}, defaultStyles, {
        fillOpacity: 0.6
      });
      return isHovered ? _extends({}, defaultStyles, {
        fillOpacity: 0.4
      }) : _extends({}, defaultStyles, {
        fillOpacity: 0.2
      });
    }, _this.onZone = function (zone) {
      return function () {
        var _this$props2 = _this.props,
            onZone = _this$props2.onZone,
            readOnly = _this$props2.readOnly;
        if (readOnly) return;
        onZone(zone.id);
      };
    }, _this.onMouseOver = function (zone) {
      return function () {
        if (_this.props.readOnly) return;

        _this.setState({
          hover: zone
        });
      };
    }, _this.onMouseOut = function () {
      return function () {
        if (_this.props.readOnly) return;

        _this.setState({
          hover: null
        });
      };
    }, _this.onSearch = function (search) {
      _this.setState({
        search: search
      }, function () {
        pause(200).then(function () {
          if (_this.state.search !== search) return;
          var zones = !search.trim().length ? [].concat(_toConsumableArray(_this.state.rawZones)) : search === 'selected' ? [].concat(_toConsumableArray(_this.state.rawZones)).filter(function (zone) {
            return !![].concat(_toConsumableArray(_this.props.selected)).find(function (sz) {
              return sz === zone.id;
            });
          }) : [].concat(_toConsumableArray(_this.state.rawZones)).filter(function (zone) {
            return zone.name.toLowerCase().includes(search.toLowerCase());
          });

          _this.setState({
            zones: zones,
            hover: null
          });
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MapZones, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          center = _props.center,
          zoom = _props.zoom,
          selected = _props.selected,
          onConfirm = _props.onConfirm,
          onClear = _props.onClear,
          readOnly = _props.readOnly;
      var _state = this.state,
          zones = _state.zones,
          hover = _state.hover,
          search = _state.search;
      return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_Map2.default, {
        zoom: zoom,
        center: center,
        hover: hover,
        options: this.constructor.MAP_OPTIONS,
        zones: zones,
        selected: selected,
        styling: this.styling,
        onZone: this.onZone,
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        containerElement: wrapper,
        mapElement: wrapper
      }), !readOnly && _react2.default.createElement(_Search2.default, {
        value: search,
        onChange: this.onSearch
      }), !readOnly && !!hover && _react2.default.createElement(_Area2.default, null, hover.name), !readOnly && !!selected.length && _react2.default.createElement(_Clear2.default, null, _react2.default.createElement(_Action2.default, null, _react2.default.createElement(_Button2.default, {
        icon: 'check',
        onClick: onConfirm
      }, 'Select')), _react2.default.createElement(_Action2.default, null, _react2.default.createElement(_Button2.default, {
        icon: 'close',
        theme: 'grey',
        onClick: onClear
      }, 'Clear'))));
    }
  }]);

  return MapZones;
}(_react.Component);

MapZones.propTypes = {
  readOnly: _propTypes2.default.bool,
  center: _propTypes2.default.object,
  zoom: _propTypes2.default.number,
  zones: _propTypes2.default.object,
  selected: _propTypes2.default.array,
  onZone: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  onClear: _propTypes2.default.func.isRequired
};
MapZones.defaultProps = {
  readOnly: false,
  center: {
    lat: 40.736083,
    lng: -73.8838593
  },
  zoom: 12,
  selected: []
};
MapZones.MAP_OPTIONS = {
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false
};
exports.default = MapZones;